import { Link } from "react-router-dom";
import { LegalPage } from "../components/LegalPage";
import { site } from "../config/site";

export default function Cgv() {
  return (
    <LegalPage
      title="Conditions générales de vente et de prestation | TN FOOD"
      description="Conditions générales de vente et de prestation de TN FOOD : restauration sur place et à emporter, prestations traiteur et événementielles."
      path="/conditions-generales-de-vente"
      updated="janvier 2026"
    >
      <h2>Partie A — Restauration sur place et à emporter</h2>

      <h3>1. Objet et champ d'application</h3>
      <p>
        Les présentes conditions s'appliquent à toute consommation sur place ou achat à emporter au restaurant TN FOOD,
        {site.address.full}.
      </p>

      <h3>2. Réservation de table</h3>
      <p>
        Les réservations sont possibles par téléphone au {site.phone} ou via le formulaire du site. Elles sont
        confirmées par TN FOOD. En cas d'empêchement, nous vous remercions d'annuler dès que possible. Les réservations
        de groupes (à partir de 6 personnes) peuvent faire l'objet de conditions particulières communiquées lors de la
        réservation.
      </p>

      <h3>3. Prix</h3>
      <p>
        Les prix sont affichés en euros TTC, service compris. TVA applicable : 10 % pour la restauration sur place ;
        10 % pour la vente à emporter à consommation immédiate et 5,5 % à consommation différée ; 20 % pour les
        boissons alcoolisées.
      </p>

      <h3>4. Moyens de paiement</h3>
      <p>Espèces, carte bancaire, titres-restaurant (Chèque Déjeuner, Ticket Restaurant, Edenred).</p>

      <h3>5. Allergènes et régimes alimentaires</h3>
      <p>
        Conformément au règlement UE n° 1169/2011, la liste des 14 allergènes majeurs est disponible sur demande auprès
        du personnel et affichée en salle. Toute allergie ou régime particulier doit être signalé avant la commande.
      </p>

      <h3>6. Hygiène et sécurité alimentaire</h3>
      <p>
        TN FOOD applique la méthode HACCP, conformément à l'article L.233-4 du Code rural et de la pêche maritime, et
        dispose d'un personnel formé à l'hygiène alimentaire.
      </p>

      <h2>Partie B — Prestations traiteur et événementielles</h2>

      <h3>1. Objet et champ d'application</h3>
      <p>
        Les présentes conditions régissent les prestations de traiteur et d'événementiel fournies par TN FOOD aux
        particuliers, professionnels et associations, en France métropolitaine.
      </p>

      <h3>2. Devis et commande</h3>
      <p>
        Le devis est gratuit et valable 30 jours à compter de sa date d'émission. La commande devient ferme après
        signature du devis et versement de l'acompte. Le consommateur dispose d'un droit de rétractation de 14 jours
        (article L.221-18 du Code de la consommation), sauf si l'exécution de la prestation commence avant la fin de ce
        délai avec son accord préalable exprès.
      </p>

      <h3>3. Prix</h3>
      <p>
        Les tarifs traiteur sont exprimés en euros hors taxes, TVA en sus (10 % pour la nourriture, 20 % pour les
        prestations de service). Le prix est établi selon le nombre de convives, le type de prestation, les options et
        le lieu de l'événement. Il peut être révisé en cas de modification du nombre de convives supérieure à 10 %.
      </p>

      <h3>4. Modalités de paiement</h3>
      <p>
        Acompte de 30 % à la réservation ; solde 7 jours avant l'événement. Paiement par virement bancaire ou carte
        bancaire. Tout retard de paiement entraîne des pénalités au taux légal majoré ainsi qu'une indemnité forfaitaire
        de recouvrement de 40 € (articles L.441-10 et D.441-5 du Code de commerce).
      </p>

      <h3>5. Exécution de la prestation</h3>
      <p>
        TN FOOD s'engage à exécuter la prestation conformément au devis accepté. Le client s'engage à déclarer un
        nombre exact de convives, à garantir l'accès au lieu de l'événement et, le cas échéant, à mettre à disposition
        les installations électriques et l'espace de travail nécessaires, dans des conditions définies ensemble au
        préalable.
      </p>

      <h3>6. Annulation</h3>
      <ul>
        <li>Annulation à plus de 30 jours de l'événement : remboursement de l'acompte, déduction faite des frais engagés.</li>
        <li>Annulation entre 30 et 7 jours avant l'événement : l'acompte est retenu.</li>
        <li>Annulation à moins de 7 jours ou le jour même : la totalité de la prestation est due.</li>
        <li>En cas de force majeure : remboursement intégral des sommes versées.</li>
      </ul>

      <h3>7. Responsabilité</h3>
      <p>
        La responsabilité de TN FOOD est limitée au montant de la prestation concernée. TN FOOD a souscrit une
        assurance responsabilité civile professionnelle et produits alimentaires auprès d'AXA France IARD, couvrant la
        France métropolitaine. Attestation fournie sur simple demande.
      </p>

      <h3>8. Force majeure</h3>
      <p>
        Les parties ne sauraient être tenues responsables d'un manquement résultant d'un cas de force majeure au sens
        de l'article 1218 du Code civil.
      </p>

      <h3>9. Confidentialité</h3>
      <p>
        Les informations échangées dans le cadre de la prestation sont traitées de manière confidentielle et ne sont
        pas cédées à des tiers.
      </p>

      <h3>10. Données personnelles</h3>
      <p>
        Les données collectées sont traitées conformément à notre{" "}
        <Link to="/politique-de-confidentialite">politique de confidentialité</Link>.
      </p>

      <h3>11. Réclamation et médiation</h3>
      <p>
        En cas de litige, le consommateur peut saisir le médiateur de la consommation : {site.mediator.name},{" "}
        {site.mediator.address} — Tél. {site.mediator.phone} — Email : {site.mediator.email} — Site :{" "}
        {site.mediator.site}. Pour les clients professionnels : recherche préalable d'un règlement amiable, puis
        compétence des tribunaux de Troyes.
      </p>

      <h3>12. Droit applicable</h3>
      <p>Les présentes conditions sont soumises au droit français.</p>

      <h3>13. Entrée en vigueur et mise à jour</h3>
      <p>
        Les présentes conditions entrent en vigueur à compter de leur publication et peuvent être mises à jour à tout
        moment ; la version applicable est celle en vigueur à la date de la commande.
      </p>
    </LegalPage>
  );
}
